/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form as BaseForm } from '@eigtech/ui/components/form'
import { cn } from '@eigtech/ui/lib/utils'
import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form'

export type FormProps<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues,
> = {
  form: UseFormReturn<TFieldValues, TContext, TTransformedValues>
  onSubmit: React.FormEventHandler<HTMLFormElement>
} & React.ComponentProps<typeof BaseForm>

export function Form<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues,
>({ children, form, className, ...props }: FormProps<TFieldValues, TContext, TTransformedValues>) {
  return (
    <FormProvider {...form}>
      <BaseForm className={cn('flex h-full flex-col gap-4', className)} {...props}>
        {children}
      </BaseForm>
    </FormProvider>
  )
}

export type FormComponent<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues,
> = typeof Form<TFieldValues, TContext, TTransformedValues>
